<template>
    <Paper class="section-header-root p-3 d-flex align-items-center">
        <h6 class="mb-0 heading">{{ label }}</h6>
        <div class="flex-grow"><slot name="left"></slot></div>
        <slot name="right" />
    </Paper>
</template>

<script>
export default {
    name: 'SectionHeader',
    props: {
        label: String,
    },
};
</script>

<style scoped>
.heading {
    letter-spacing: 1px;
    font-size: 0.7rem;
    font-weight: 600 !important;
    text-transform: uppercase;
}

.section-header-root {
    border-top: 2px solid var(--secondary);
}
</style>
